export const QUERY_KEYS = {
  THEME_DETAIL: "THEME_DETAIL",
  AI_OPPORTUNITIES: "AI_OPPORTUNITIES",

  AI_RECOMMEND_TOPICS: "ai-recommend-topics",
  KOL_FOLLOW: "kol-follow",
  TOKEN_SEARCH: "token-search",
  TOP_PROJECT: "top-project",
  FUNDRAISED: "fundraised",
  TOKEN_DASHBOARD: "token-dashboard",
  STOCK_DASHBOARD: "stock-dashboard",
  AGGREGATED_USER_POST: "aggregated-user-post",
  AGGREGATED_HOME_FEED_POST: "aggregated-home-feed-post",
  TOKEN_SEEK_KLINE: "token-seek-kline",
  AGGREGATED_USER_SCORE: "aggregated-user-score",

  CHAT_MESSAGE_DETAIL: "CHAT_MESSAGE_DETAIL",
  CHAT_MESSAGE_AGENTS: "CHAT_MESSAGE_AGENTS",
  FEED_RATE: "FEED_RATE",
  CHAT_DETAIL: "CHAT_DETAIL",
  RECOMMENDED_QUESTION: "RECOMMENDED_QUESTION",
  RECOMMENDED_SCOPED_QUESTION: "RECOMMENDED_SCOPED_QUESTION",
  CHAT_HISTORY: "CHAT_HISTORY",
  GET_BIND_LINK: "GET_BIND_LINK",
  GET_BIND_LIST: "GET_BIND_LIST",
  CREDENTIAL_DAILY_POINTS: "CREDENTIAL_DAILY_POINTS",
  CREDENTIAL_CUSTOM_ME: "CREDENTIAL_CUSTOM_ME",
  CREDENTIAL_POST_TASK_LIST: "CREDENTIAL_POST_TASK_LIST",
  CREDENTIAL_CHECK_IN_STATUS: "CREDENTIAL_CHECK_IN_STATUS",
  CREDENTIAL_USER_CREDITS: "CREDENTIAL_USER_CREDITS",
  SHARE_DETAIL: "SHARE_DETAIL",
  BIND_TWITTER: "BIND_TWITTER",
  HOME_LIST_RECOMMEND: "HOME_LIST_RECOMMEND",
  GET_BIND: "GET_BIND",
  USER_INFO_BY_HANDLE: "USER_INFO_BY_HANDLE",
  GET_PROFILE_BY_HANDLE: "GET_PROFILE_BY_HANDLE",
  AURA_SHARE: "AURA_SHARE",
  GET_MEMBER_TOP_LADDER: "GET_MEMBER_TOP_LADDER",
  GET_PROFILES: "GET_PROFILES",
  INVITE_CODE_CHECK_ACCESS: "INVITE_CODE_CHECK_ACCESS",
  INVITE_CODE_CHECK_VALIDATE: "INVITE_CODE_CHECK_VALIDATE",
  INVITE_CODE_BIND: "INVITE_CODE_BIND",
  AI_QUESTIONS: "AI_QUESTIONS",
  GET_PASSKEY_LIST: "GET_PASSKEY_LIST",
  FEED_FEEDS: "FEED_FEEDS",
  SEARCH_GROUP: "SEARCH_GROUP",
  SEARCH_MULTIPLE: "SEARCH_MULTIPLE",
  CARD_TOKEN_DETAIL: "CARD_TOKEN_DETAIL",
  SOCIAL_FEEDS: "SOCIAL_FEEDS",
  LATEST_NEWS: "LATEST_NEWS",
  ARTICLES: "ARTICLES",
  OPEN_DATA_SEARCH: "OPEN_DATA_SEARCH",
  SWAP_TOKEN_EVM: "SWAP_TOKEN_EVM",
  SWAP_TOKEN_SOLANA: "SWAP_TOKEN_SOLANA",
  ECOSYSTEMS_RANKING: "ECOSYSTEMS_RANKING",
  AGENT_MARKET_PAIRS: "AGENT_MARKET_PAIRS",
  AGENT_MARKET_PAIR_BY_SYMBOL: "AGENT_MARKET_PAIR_BY_SYMBOL",
  PAIRS_DETAIL: "PAIRS_DETAIL",
  TOKEN_DETAILS_MARKET: "TOKEN_DETAILS_MARKET",
  POOL_DETAILS_MARKET: "POOL_DETAILS_MARKET",
  STOCK_DETAILS_MARKET: "STOCK_DETAILS_MARKET",
  AGENT_REPORTS_TIMELINE: "AGENT_REPORTS_TIMELINE",
  TA_SIGNAL_PRICE_CHART: "TA_SIGNAL_PRICE_CHART",
  SYMBOL_FAQ: "SYMBOL_FAQ",
  SYMBOL_SEARCH: "SYMBOL_SEARCH_V3",
  PAYMENT_HISTORY: "PAYMENT_HISTORY",
  MEMBER_FEATURE: "MEMBER_FEATURE",
  MEMBER_USE_PLAN: "MEMBER_USE_PLAN",
  REBATE_SUMMARY: "REBATE_SUMMARY",
  REFERRAL_LIST: "REFERRAL_LIST",
  REBATE_LIST: "REBATE_LIST",
  QUEST_INVITED_REWARDS: "QUEST_INVITED_REWARDS",
  MEMBER_FEATURE_EQUITYLIST: "MEMBER_FEATURE_EQUITYLIST",
  MEMBER_RETENTION_STATS: "MEMBER_RETENTION_STATS",
  /** GET /members/equities/grant/{code} — grantable quantity */
  MEMBER_EQUITY_GRANT: "MEMBER_EQUITY_GRANT",
  MEMBER_USER_REWARDS: "member_user_rewards",
  ONBOARDING_AGENTS: "onboarding-agents",
  GET_OWNER_BY_UNIQUE_KEY: "GET_OWNER_BY_UNIQUE_KEY",
  UPDATE_OWNER_SETTING: "UPDATE_OWNER_SETTING",
  PAYMENT_LIST_PAYMENT: "PAYMENT_LIST_PAYMENT",
  RATING_REPORT: "RATING_REPORT",
  TOKENS_RANKING: "TOKENS_RANKING",
  RANKING_NEWS: "RANKING_NEWS",
  BADGES_CLAIMABLE: "BADGES_CLAIMABLE",
  TOKENS_RANKING_INFINITE: "TOKENS_RANKING_INFINITE",
  STOCK_DASHBOARD_INFINITE: "STOCK_DASHBOARD_INFINITE",
  PORTFOLIO_ASSETS_INFINITE: "PORTFOLIO_ASSETS_INFINITE",
  PORTFOLIO_PERFORMANCE: "PORTFOLIO_PERFORMANCE",
  PORTFOLIO_ASSETS: "PORTFOLIO_ASSETS",
  STOCK_RANKING_INFINITE: "STOCK_RANKING_INFINITE",
  CRYPTO_FUNDRAISED_INFINITE: "CRYPTO_FUNDRAISED_INFINITE",
  TOKEN_DASHBOARD_INFINITE: "TOKEN_DASHBOARD_INFINITE",
  TOP_PROJECT_INFINITE: "TOP_PROJECT_INFINITE",
  RECOMMEND_QUESTION: "RECOMMEND_QUESTION",
  TOKENS_BY_IDS: "TOKENS_BY_IDS",
  STOCKS_BY_IDS: "STOCKS_BY_IDS",
  ASSET_INFO: "ASSET_INFO",
  RANKING_THEMES: "RANKING_THEMES",
  POSITION_ORDERS: "POSITION_ORDERS",
  POSITION_BROKERS: "POSITION_BROKERS",
  THEMES: "THEMES",
  RECOMMEND_SCOPE_CONTENTS: "RECOMMEND_SCOPE_CONTENTS",
  MARKET_SUMMARY: "MARKET_SUMMARY",
  MEMBER_EQUITY_LIST: "MEMBER_EQUITY_LIST",
  AGENT_PREFERENCES: "AGENT_PREFERENCES",
  AGENT_REPORT_LIST: "AGENT_REPORT_LIST",
  AGENT_DAILY_REPORT: "AGENT_DAILY_REPORT",
  AGENT_REPORTS_ASSET_ID: "AGENT_REPORTS_ASSET_ID",
  MILSTONE_DATA_PRICE: "MILSTONE_DATA_PRICE",

  // Stock Home Page 相关查询键
  STOCK_HOME_TOP_THEMES: "STOCK_HOME_TOP_THEMES",
  STOCK_HOME_MARKET_INDICATOR: "STOCK_HOME_MARKET_INDICATOR",
  STOCK_HOME_INDICES_TRADING_DATA: "STOCK_HOME_INDICES_TRADING_DATA",
  HOME_THEMES_IN_PLAY: "HOME_THEMES_IN_PLAY",
  HOME_FEATURED_CIK_LIST: "HOME_FEATURED_CIK_LIST",
  /** 按 ids 查询精选 CIK 详情（getFeaturedCikList ids 参数） */
  FEATURED_CIK_BY_IDS: "FEATURED_CIK_BY_IDS",
  HOT_NEWS_QUERY_KEY: "HOT_NEWS",
  /** 新闻频道 ranking themes（与 newsRanking.getRankingThemeRows 同源） */
  NEWS_RANKING_THEME_ROWS: "NEWS_RANKING_THEME_ROWS",
  ETF_HOLDINGS: "ETF_HOLDINGS",
  ETF_PROFILE: "ETF_PROFILE",
  STOCK_DIVIDENDS: "STOCK_DIVIDENDS",
  STOCK_SPLITS: "STOCK_SPLITS",
  ETF_HOLDINGS_OVERVIEW: "ETF_HOLDINGS_OVERVIEW",
  STOCK_SPLITS_OVERVIEW: "STOCK_SPLITS_OVERVIEW",

  STOCK_MARKET_SCHEDULE: "STOCK_MARKET_SCHEDULE",
  FETCH_FOREXES: "FETCH_FOREXES",
  USER_FOLDERS: "USER_FOLDERS",
  ASSET_DETAIL: "ASSET_DETAIL",

  ALPHA_PICK_DETAIL: "ALPHA_PICK_DETAIL",

  // AlphaPick 页面相关查询键
  ALPHA_PICK_SUMMARY: "ALPHA_PICK_SUMMARY",
  ALPHA_PICK_EDGEN_PICKS: "ALPHA_PICK_EDGEN_PICKS",
  ALPHA_PICK_EARNINGS: "ALPHA_PICK_EARNINGS",
  ALPHA_PICK_IPO: "ALPHA_PICK_IPO",
  ALPHA_PICK_TA: "ALPHA_PICK_TA",
  HOT_SEARCH_THEMES: "HOT_SEARCH_THEMES",
  ANALYZING_DATA: "ANALYZING_DATA",

  /** GET /v2/notify/message — infinite cursor list */
  NOTIFY_MESSAGE_INFINITE: "NOTIFY_MESSAGE_INFINITE",
  /** GET /v2/notify/signals/holdings — infinite cursor list */
  NOTIFY_HOLDINGS_SIGNALS_INFINITE: "NOTIFY_HOLDINGS_SIGNALS_INFINITE",
  TRACKER_LIST: "TRACKER_LIST",
  TRACKER_DETAIL: "TRACKER_DETAIL",
  TRACKER_RECORDS: "TRACKER_RECORDS",
  TRACKER_RECORD_DETAIL: "TRACKER_RECORD_DETAIL",
  GOAL_LIST: "GOAL_LIST",
  GOAL_DETAIL: "GOAL_DETAIL",
  GOAL_STATS: "GOAL_STATS",
  INVEST_MOVES_ED_FLAGGED_FOR_YOU: "INVEST_MOVES_ED_FLAGGED_FOR_YOU",
  INVEST_MOVES_NEXT_MOVES: "INVEST_MOVES_NEXT_MOVES",

  FITNESS_SCORE: "FITNESS_SCORE",
  GOAL_FITNESS_IMPACT: "GOAL_FITNESS_IMPACT",
} as const;

export const LOCAL_STORAGE_KEYS = {
  ASK_AI_HISTORY: "ask-ai-history",
  CLIENT_UUID: "_client_uuid",
  NEXT_PAYMENT_ERROR: "NEXT_PAYMENT_ERROR",
  NEXT_PAYMENT_ERROR_MENU: "NEXT_PAYMENT_ERROR_MENU",
  CHAT_ID: "chat_id",
  HIDDEN_CHAT_ID: "hidden_chat_id",
  ONBOARDING_AGENT_SHOWN: "onboarding-agent-shown",
  NOTIFICATION_CONFIG: "notification_config",
  /** Record<ownerId, boolean> — NotificationSignalHeader dismissed after Ask Ed */
  NOTIFICATION_SIGNAL_HEADER_DISMISSED: "notification_signal_header_dismissed",
  /**
   * Record<ownerId, boolean> — marks owners who reached credit <= 0 after
   * Ask Ed was dismissed; used to re-arm Ask Ed display when credit recovers.
   */
  NOTIFICATION_SIGNAL_HEADER_CREDIT_EXHAUSTED:
    "notification_signal_header_credit_exhausted",
  SURVEY_GUIDE_SHOWN: "survey-guide-shown",
  IS_INIT_PORTFOLIO: "is-init-portfolio",
  ALPHA_GIFT_COUNT: "alpha_gift_count",
  // App Rating Modal - 上次展示时间（7 天判断）
  APP_RATING_MODAL_LAST_SHOWN: "app_rating_modal_last_shown",
  // 用户是否对APP进行了评分
  APP_RATING_MODAL_RATED: "app_rating_modal_rated",
  // App 升级引导弹窗 - 上次展示时间（7 天判断）
  APP_VERSION_UPDATE_MODAL_LAST_SHOWN: "app_version_update_modal_last_shown",
  /** @deprecated onboarding_guide 首问机制已随 V3 沉浸式 onboarding 删除（无引用，待清理） */
  ONBOARDING_CHAT_GUIDE_INITIATED: "onboarding_chat_guide_initiated",
  /** save_goal 草稿幂等 ID（middleware 写入 localStorage，confirm-save 优先读取） */
  GOAL_ID: "goal_id",
  /** onboarding deeplink quiz resultId payload */
  ONBOARDING_QUIZ_RESULT_CONTEXT: "onboarding_quiz_result_context",
  /** onboarding fetched quiz result payload cache */
  ONBOARDING_QUIZ_RESULT_CACHE: "onboarding_quiz_result_cache",
  /** present_risk maybe_later 已展示过 Gift Set Goal Paywall（全局仅一次） */
  GIFT_SET_GOAL_PAYWALL_MAYBE_LATER_SEEN:
    "gift_set_goal_paywall_maybe_later_seen",
  /** Brief 页上次划走卡片已读时间（epoch ms）；读方随 V3.0.7 旧问候块下线，写方保留（useBriefPageState） */
  BRIEF_LAST_READ_AT: "brief_last_read_at",
  /** Brief 手势引导「已看过」（首次滑动后落定；清缓存/换设备重出一次） */
  BRIEF_SWIPE_HINT_SEEN: "brief_swipe_hint_seen",
  /** Record<ownerId, BriefQuotaRemoteSnapshot> — Brief 当日剩余额度本地兜底 */
  BRIEF_DAILY_QUOTA: "brief_daily_quota_state",
  /** Record<ownerId, yyyyMMdd> — Daily Market 最后一次已读报告 date（§2.4） */
  DAILY_MARKET_LAST_READ_DATE: "daily_market_last_read_date",
  /** Record<ownerId, goalId[]> — Plan Banner A 类 Not now 持久化过滤 */
  PLAN_ACTIVITY_BANNER_DISMISSED_GOAL_IDS:
    "plan_activity_banner_dismissed_goal_ids",
  /** Record<ownerId, Record<goalId, expiryTs>> — Plan Banner A 类 Activate goal 当日隐藏（本地时区今天结束过期） */
  PLAN_ACTIVITY_BANNER_SNOOZED_GOAL_IDS:
    "plan_activity_banner_snoozed_goal_ids",
  /** Record<ownerId, Record<goalId, expiryTs>> — My goals · Pending 卡滑动 skip 当日隐藏（本地时区今天结束过期） */
  PLAN_PENDING_GOAL_SKIPPED_IDS: "plan_pending_goal_skipped_ids",
  /** 摘要条问候语库「上次句 id」（不连续重复，AC7；per 设备，V3.0.7 A.7） */
  BRIEF_SUMMARY_BAR_LAST_GREETING_ID: "brief_summary_bar_last_greeting_id",
  /** {n} new 徽标本地清除标记（T8 mock 本地态；值=本地自然日 yyyy-MM-dd，跨日失效） */
  BRIEF_NEW_INDICATOR_CLEARED: "brief_new_indicator_cleared",
  /** Record<ownerId, {date, task_ids}> — 汇报摘要条本地 watermark（V3.0.7 现成接口拼装期：new_count/bar_state 派生源） */
  REPORT_SUMMARY_WATERMARK: "report_summary_watermark",
} as const;

export const SESSION_STORAGE_KEYS = {
  IS_FIRST_LOAD: "IS_FIRST_LOAD",
  /**
   * PC /chat Tab pending entry（sessionStorage，一次性消费）。
   * 写入：openChatTabWithPendingEntry；读取并删除：consumeChatTabPendingEntry。
   */
  CHAT_TAB_PENDING_ENTRY: "chat_tab_pending_entry",
} as const;

export const ExtensionMessageType = {
  LOGIN_SUCCESS: "EXTENSION_LOGIN_SUCCESS",
  LOGOUT_SUCCESS: "EXTENSION_LOGOUT_SUCCESS",
} as const;

export const URL_ACTION = {
  GO_TO_AURA: "goToAura",
} as const;

export const APP_SCHEME_PATH = {
  EDGEN: "edgen://",
  SNAPTRADE: "edgen://snaptrade-callback",
  OAUTH: "edgen://oauth-callback",
  QUEST: "edgen://quest-callback",
} as const;
